/**
 * Fime – Language Switcher
 */

const langTrigger = document.querySelector('.lang-trigger');
const langDropdown = document.querySelector('.lang-dropdown');

if (langTrigger && langDropdown) {
	langTrigger.addEventListener('click', function (e) {
		e.stopPropagation();
		const isOpen = !langDropdown.classList.contains('hidden');
		langDropdown.classList.toggle('hidden', isOpen);
		langTrigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
	});

	document.addEventListener('click', function () {
		langDropdown.classList.add('hidden');
		langTrigger.setAttribute('aria-expanded', 'false');
	});
}
